import type { ReactNode } from "react";

interface OptionTileProps {
  selected: boolean;
  onToggle: () => void;
  title: ReactNode;
  detail?: ReactNode;
  marker?: ReactNode;
  disabled?: boolean;
}

/** A tappable checkbox-style row (checklists, services, payment methods). */
export function OptionTile({
  selected,
  onToggle,
  title,
  detail,
  marker,
  disabled,
}: OptionTileProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={selected}
      disabled={disabled}
      onClick={onToggle}
      className={`flex w-full items-start gap-3.5 rounded-[var(--radius-card)] border-2 px-4 py-[15px] text-left transition-colors disabled:opacity-50 ${
        selected ? "border-accent bg-accent-tint" : "border-border bg-surface hover:border-accent"
      }`}
    >
      <span
        aria-hidden="true"
        className={`inline-flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-[var(--radius-card)] text-[14px] font-bold ${
          selected ? "bg-accent text-on-accent" : "bg-accent-tint text-accent"
        }`}
      >
        {selected ? "✓" : marker}
      </span>
      <span>
        <span className="block text-[15px] font-bold text-text">{title}</span>
        {detail ? <span className="block text-[13.5px] text-text-muted">{detail}</span> : null}
      </span>
    </button>
  );
}
